import Dexie from 'dexie';

const db = new Dexie('CieslaNet');

db.version(1).stores({
  treeCache: 'key, updatedAt',
});

export default db;
